module.exports = __webpack_public_path__ + "img/click and drag.51759a31.jpg";